import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CreateAsset from './submodules/create';
import ListAsset from './submodules/list';
import ViewAsset from './submodules/view';

const UtilsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.utilities}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.utilities].getAllAssets]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListAsset}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.utilities}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.utilities].viewAsset]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/view`}
				component={ViewAsset}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.utilities}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.utilities].createNewAsset]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateAsset}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default UtilsDashboard;
